import { CardAuthor } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledUtility = styled.div`
  display: flex;
  align-items: center;
`

export const StyledWrapper = styled.div`
  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .popover {
    .popover-menu__btn {
      display: flex;
      width: 1rem;
      height: 1rem;
      align-items: center;
      justify-content: center;
      padding: 0;
      background: transparent;

      &:hover {
        background-color: transparent;
      }

      .popover-menu__content {
        &.--position-bottom {
          &.--align-end {
            &::before {
              right: 12.5px;
            }
          }
        }
      }
    }
  }
`
export const StyledCardAuthor = styled(CardAuthor)`
  padding: 0;
  .expert-wrapper {
    display: flex;
    align-items: center;
  }
  &.with-popover {
    padding-right: 1.6rem;
  }
`
